import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claims`;

export interface GetClaimRmaSupplierInfosQueryArgs {
  claimId: string;
}

export const getClaimRmaSupplierInfosRequest = ({
  claimId,
}: GetClaimRmaSupplierInfosQueryArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimId}/rma/supplier`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getClaimRmaSupplierInfosQuery = async (
  args: GetClaimRmaSupplierInfosQueryArgs,
): Promise<BackResponse<Record<string, unknown>> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Record<string, unknown>>>(
      getClaimRmaSupplierInfosRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
